import axios from "axios"
import { toast } from "react-toastify"
import { AuthToken } from "../components/security/authToken"

export const fetchApi = async (url, account, inProgress, instance) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  return await toast.promise(
    axios.get(url, {
      headers: {
        "Conent-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
      },
    }),
    {
      // pending: "Henter opplysninger",
      // success: "Opplysningene er hentet",
      error: "Feil",
    }
  )
}

export const fetchApiStandard = async (url, account, inProgress, instance) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  return axios.get(url, {
    headers: {
      "Conent-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
    },
  })
}

export const fetchApiAnonymous = async url => {
  const response = await toast.promise(
    axios.get(url, {
      headers: {
        "Conent-Type": "application/json",
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY as string,
      },
    }),
    {
      // pending: "Henter opplysninger",
      // success: "Opplysningene er hentet",
      error: "Feil",
    }
  )

  return response
}

export const postApi = async (url, obj, account, inProgress, instance) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = await toast.promise(
    axios.post(url, obj, {
      headers: {
        "Conent-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY as string,
      },
    }),
    {
      // pending: "Oppretter",
      // success: "Opprettet",
      error: "Feil",
    }
  )

  return response
}

export const postApiNoToast = async (
  url,
  obj,
  account,
  inProgress,
  instance
) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = axios.post(url, obj, {
    headers: {
      "Conent-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY as string,
    },
  })

  return response
}

export const postApiAnonymous = async (url, obj) => {
  const response = await toast.promise(
    axios.post(url, obj, {
      headers: {
        "Conent-Type": "application/json",
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY as string,
      },
    }),
    {
      // pending: "Oppretter",
      // success: "Opprettet",
      error: "Feil",
    }
  )

  return response
}

export const patchApi = async (url, obj, account, inProgress, instance) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = await toast.promise(
    axios.patch(url, obj, {
      headers: {
        "Conent-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY as string,
      },
    }),
    {
      // pending: "Oppdaterer",
      // success: "Oppdatert",
      error: "Feil",
    }
  )

  return response
}

export const patchApiNoObject = async (url, account, inProgress, instance) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = await toast.promise(
    axios.patch(url, {
      headers: {
        "Conent-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY as string,
      },
    }),
    {
      // pending: "Oppdaterer",
      // success: "Oppdatert",
      error: "Feil",
    }
  )

  return response
}

export const patchApiNoToast = async (
  url,
  obj,
  account,
  inProgress,
  instance
) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = axios.patch(url, obj, {
    headers: {
      "Conent-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
    },
  })

  return response
}

export const patchApiAnonymous = async (url, obj) => {
  const response = await toast.promise(
    axios.patch(url, obj, {
      headers: {
        "Conent-Type": "application/json",
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
      },
    }),
    {
      // pending: "Oppdaterer",
      // success: "Oppdatert",
      error: "Feil",
    }
  )

  return response
}

export const deleteApi = async (url, account, inProgress, instance) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = await toast.promise(
    axios.delete(url, {
      headers: {
        "Conent-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
      },
    }),
    {
      // pending: "Sletter",
      // success: "Slettet",
      error: "Feil",
    }
  )

  return response
}

export const deleteApiAnonymous = async url => {
  const response = await toast.promise(
    axios.delete(url, {
      headers: {
        "Conent-Type": "application/json",
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
      },
    }),
    {
      // pending: "Venter",
      // success: "Slettet",
      error: "Feil",
    }
  )

  return response
}

//--------Documet Api-----------

export const postGetDocumentApi = async (
  url,
  obj,
  account,
  inProgress,
  instance
) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  const response = axios.post(url, obj, {
    headers: {
      "Conent-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
    },
  })

  return response
}

export const fetchDownLoadFileApi = async (
  url,
  account,
  inProgress,
  instance
) => {
  const accessToken = await AuthToken(account, inProgress, instance)

  return await toast.promise(
    axios.get(url, {
      headers: {
        "Conent-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Ocp-Apim-Subscription-Key": process.env.GATSBY_API_KEY,
      },
      responseType: "blob",
    }),
    {
      // pending: "Henter opplysninger",
      success: "Dokumentet er lastet ned",
      error: "Feil",
    }
  )
}
